import SEO from "../common/SEO";
import KYouthBreadcrumb from "../common/breadcrumb/KYouthBreadcrumb";
import KYouthFooter from "../common/footer/KYouthFooter";
import KYouthHeader from "../common/header/KYouthHeader";
import KYouthService from "../components/about-us-one/KYouthService";
import KYouthAbout from "../components/about/KYouthAbout";
import KYouthProgramFramework from "../components/about/KYouthProgramFramework";
import KYouthProgramme1 from "../components/about/KYouthProgramme1";
import KYouthStats from "../components/about/KYouthStats";
import KYouthPartners from "../components/instructor/KYouthPartners";
import KYouthTestimonialFour from "../components/testimonial-section/KYouthTestimonialFour";
import KYouthFaq from "./innerpages/KYouthFaq";

const LandingPage = () => {
  return (
    <>
      <SEO title="K-Youth" />

      <KYouthHeader />

      <KYouthBreadcrumb
        title={
          <h3 className="title" style={{ fontWeight: 900 }}>
            K-YOUTH DEVELOPMENT PROGRAMME 2026
            {/* <span style={{ color: "var(--color-khazanah)" }}>K-YOUTH</span>{" "} */}
          </h3>
        }
        rootUrl="/"
      />

      <KYouthAbout />

      <KYouthProgramFramework />

      <KYouthStats />

      {/* <KYouthApplicationProcess /> */}

      {/* <KYouthHightlights /> */}

      <KYouthService />

      <KYouthPartners />
      <KYouthProgramme1 />

      {/* <KYouthAbout2 /> */}

      {/* <KYouthAbout3 /> */}

      {/* <KYouthAboutUsTeam /> */}

      <KYouthTestimonialFour />
      {/* <KYouthTestimonial1 /> */}
      {/* <KYouthTestimonial /> */}

      <KYouthFaq />

      {/* <KYouthTestimonialSection classes="counterup-overlay-top" /> */}

      <KYouthFooter />
    </>
  );
};

export default LandingPage;
